import SeoHead from "@/components/SeoHead";
import { Link } from "wouter";
import { Home, Search } from "lucide-react";

export default function NotFound() {
  return (
    <>
      <SeoHead title="Sidan hittades inte (404)" description="Sidan du söker finns inte. Gå tillbaka till startsidan eller utforska våra uterum." path="/404" noindex />
      <div className="min-h-[60vh] flex items-center justify-center py-16">
        <div className="container max-w-lg text-center">
          <p className="text-8xl font-heading font-bold text-navy/10 mb-4">404</p>
          <h1 className="font-heading text-3xl font-bold text-navy mb-3">Sidan hittades inte</h1>
          <p className="text-muted-foreground mb-8 leading-relaxed">Sidan du söker finns inte eller har flyttats. Använd länkarna nedan för att hitta det du letar efter.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link href="/uterum/" className="inline-flex items-center justify-center gap-2 bg-navy text-white px-6 py-3 rounded-lg font-medium hover:bg-navy/90 transition-colors">
              <Search className="w-4 h-4" />Utforska uterum
            </Link>
            <Link href="/" className="inline-flex items-center justify-center gap-2 bg-sand text-navy px-6 py-3 rounded-lg font-medium hover:bg-sand/80 transition-colors">
              <Home className="w-4 h-4" />Startsidan
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
